<script setup lang="ts">
import WalletButton from '@/components/web3/WalletButton.vue';
import { EXTERNAL_LINKS } from '@/constants/links';
import { SupportedWallets } from '@/providers/wallet.provider';
import { useWalletHelpers } from '@/composables/useWalletHelpers';
import { useUserAgent } from '@/composables/useUserAgent';

interface Props {
  isVisible?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  isVisible: false,
});

const emit = defineEmits(['close']);

const { isMobile } = useUserAgent();
const { getIsMetaMaskBrowser } = useWalletHelpers();

const wallets = SupportedWallets.filter(id => {
  // hide metamask wallet on all mobile browsers except metamask
  if (id === 'metamask' && isMobile && !getIsMetaMaskBrowser()) {
    return false;
  }

  // Hide all wallets except metamask on metamask browser
  if (id !== 'metamask' && getIsMetaMaskBrowser()) {
    return false;
  }

  return id !== 'safe';
});
</script>

<template>
  <BalModal
    :show="props.isVisible"
    title="Connect to a wallet"
    @close="emit('close')"
  >
    <div>
      <WalletButton v-for="wallet in wallets" :key="wallet" :wallet="wallet" />
      <div
        class="p-4 bg-gradient-to-b from-gray-50 dark:from-gray-900 to-gray-100 dark:to-gray-850 rounded-lg"
      >
        <h6>{{ $t('newToEthereum') }}</h6>
        <p class="text-sm">
          {{ $t('setUpEthereumWallet') }}
          <BalLink :href="EXTERNAL_LINKS.Ethereum.Wallets" external>
            {{ $t('learnMore') }}
            <span class="align-middle">
              <BalIcon name="arrow-up-right" size="sm" />
            </span>
          </BalLink>
        </p>
      </div>
    </div>
  </BalModal>
</template>
